import React, { useState, useEffect } from 'react';

const ImageSlider = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!isPaused) {
      const intervalId = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % slides.length);
      }, 5000);
      return () => clearInterval(intervalId);
    }
  }, [isPaused, slides.length]);

  const goToNext = () => setCurrentIndex((prev) => (prev + 1) % slides.length);
  const goToPrev = () => setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <div className="relative w-full overflow-hidden rounded-xl group">
      <div
        className="flex transition-all duration-700 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div
            key={index}
            className="flex-shrink-0 w-full relative cursor-pointer"
            onClick={() => setIsPaused((p) => !p)}
          >
            <img
              src={slide.imageSrc}
              alt={slide.imageAlt}
              className="w-full h-96 object-cover"
            />
            {/* Slide caption */}
            {slide.caption && (
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <p className="text-white text-sm font-medium">{slide.caption}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Pause indicator */}
      {isPaused && (
        <div className="absolute top-3 right-3 bg-black/50 text-white text-xs px-2 py-1 rounded">
          Paused
        </div>
      )}

      {/* Slide counter */}
      <div className="absolute top-3 left-3 bg-black/40 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
        {currentIndex + 1} / {slides.length}
      </div>

      {/* Prev button */}
      <button
        onClick={goToPrev}
        className="absolute top-1/2 left-3 transform -translate-y-1/2 text-white text-2xl bg-[#0077b6]/80 hover:bg-[#0077b6] p-2.5 rounded-full transition"
        aria-label="Previous slide"
      >
        &#10094;
      </button>

      {/* Next button */}
      <button
        onClick={goToNext}
        className="absolute top-1/2 right-3 transform -translate-y-1/2 text-white text-2xl bg-[#0077b6]/80 hover:bg-[#0077b6] p-2.5 rounded-full transition"
        aria-label="Next slide"
      >
        &#10095;
      </button>

      {/* Dot indicators */}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentIndex(i)}
            aria-label={`Go to slide ${i + 1}`}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
              i === currentIndex ? 'bg-white scale-125' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;